import React from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Radio,
  Space,
  Card,
  Row,
  Col,
  Avatar,
  Typography,
} from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const Account: React.FC = () => {
  const [primaryForm] = Form.useForm();
  const [accountingForm] = Form.useForm();
  const [paymentForm] = Form.useForm();

  return (
    <div style={{ backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
      {/* Main Content */}
      <div
        style={{
          display: "flex",
          marginTop: "39px",
          width: "100%",
          padding: "0 24px",
          flexDirection: "column",
          alignItems: "stretch",
        }}
        className="account-content"
      >
        {/* Page Title */}
        <div
          style={{
            alignSelf: "start",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "59px",
          }}
        >
          <UserOutlined
            style={{
              fontSize: "36px",
              color: "#4D4D4D",
            }}
          />
          <Title
            level={2}
            style={{
              margin: 0,
              fontFamily:
                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
              fontSize: "24px",
              color: "#4D4D4D",
              fontWeight: "700",
              letterSpacing: "0.5px",
              lineHeight: "1",
            }}
          >
            Account Information
          </Title>
        </div>

        {/* Cards Row */}
        <Row gutter={[20, 25]}>
          {/* Points of Contact Card */}
          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
                height: "fit-content",
              }}
              className="points-of-contact-card"
            >
              {/* Card Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "11px",
                }}
              >
                <Title
                  level={4}
                  style={{
                    margin: 0,
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "20px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    lineHeight: "0.8",
                    letterSpacing: "0.5px",
                  }}
                >
                  Points of Contact
                </Title>
                <Button
                  style={{
                    borderRadius: "6px",
                    backgroundColor: "#F5F5F5",
                    border: "none",
                    color: "#4D4D4D",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "1",
                  }}
                >
                  Edit
                </Button>
              </div>

              <div
                style={{
                  borderTop: "1px solid #CCC",
                  marginBottom: "20px",
                }}
              />

              {/* Primary Point of Contact */}
              <div style={{ marginBottom: "29px" }}>
                <Title
                  level={5}
                  style={{
                    margin: "0 0 20px 0",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "16px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    lineHeight: "1",
                    letterSpacing: "0.5px",
                  }}
                >
                  Primary Point of Contact
                </Title>

                <Form form={primaryForm} layout="vertical">
                  <Row gutter={25}>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            First Name
                          </Text>
                        }
                        name="firstName"
                        initialValue="Andrew"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Last Name
                          </Text>
                        }
                        name="lastName"
                        initialValue="Sutton"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={25}>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Email
                          </Text>
                        }
                        name="email"
                        initialValue="andrew.sutton@bikeemporium.com"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Phone
                          </Text>
                        }
                        name="phone"
                        initialValue="1(123) 444 2222"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>

              <div
                style={{
                  borderTop: "1px solid #CCC",
                  marginBottom: "20px",
                }}
              />

              {/* Accounting Point of Contact */}
              <div>
                <Title
                  level={5}
                  style={{
                    margin: "0 0 20px 0",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "16px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    lineHeight: "1",
                    letterSpacing: "0.5px",
                  }}
                >
                  Accounting Point of Contact
                </Title>

                <Form form={accountingForm} layout="vertical">
                  <Form.Item name="sameAsPrimary" valuePropName="checked">
                    <Checkbox
                      style={{
                        fontFamily:
                          "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                        fontSize: "16px",
                        color: "#4D4D4D",
                        fontWeight: "400",
                        lineHeight: "1",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Same as primary point of contact
                    </Checkbox>
                  </Form.Item>

                  <Row gutter={25}>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            First Name
                          </Text>
                        }
                        name="accountingFirstName"
                        initialValue="Lisa"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Last Name
                          </Text>
                        }
                        name="accountingLastName"
                        initialValue="Jameson"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={25}>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Email
                          </Text>
                        }
                        name="accountingEmail"
                        initialValue="lisa.jameson@bikeemporium.com"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={
                          <Text
                            style={{
                              fontFamily:
                                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                              fontSize: "16px",
                              color: "#4D4D4D",
                              fontWeight: "400",
                              lineHeight: "1",
                            }}
                          >
                            Phone
                          </Text>
                        }
                        name="accountingPhone"
                        initialValue="1(123) 444 2222"
                      >
                        <Input
                          style={{
                            borderRadius: "4px",
                            border: "1px solid #DDD",
                            backgroundColor: "#FAFAFA",
                            color: "#777",
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: "1",
                            padding: "10px",
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
          </Col>

          {/* Banking Information Card */}
          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
                height: "fit-content",
              }}
              className="banking-info-card"
            >
              {/* Card Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "11px",
                }}
              >
                <Title
                  level={4}
                  style={{
                    margin: 0,
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "20px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    lineHeight: "0.8",
                    letterSpacing: "0.5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Banking Information & Payment Preferences
                </Title>
                <Button
                  style={{
                    borderRadius: "6px",
                    backgroundColor: "#F5F5F5",
                    border: "none",
                    color: "#4D4D4D",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "1",
                  }}
                >
                  Edit
                </Button>
              </div>

              <div
                style={{
                  borderTop: "1px solid #CCC",
                  marginBottom: "20px",
                }}
              />

              {/* Payment Preferences */}
              <div>
                <Title
                  level={5}
                  style={{
                    margin: "0 0 20px 0",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                    fontSize: "16px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    lineHeight: "1",
                    letterSpacing: "0.5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Preferred Payment Preferences
                </Title>

                <Form form={paymentForm} layout="vertical">
                  <Form.Item name="paymentMethod" initialValue="check">
                    <Radio.Group>
                      <Space direction="vertical">
                        <Radio
                          value="check"
                          style={{
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            color: "#777",
                            fontWeight: "400",
                            lineHeight: "1",
                          }}
                        >
                          Check
                        </Radio>
                        <Radio
                          value="ach"
                          style={{
                            fontFamily:
                              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                            fontSize: "16px",
                            color: "#777",
                            fontWeight: "400",
                            lineHeight: "1",
                          }}
                        >
                          ACH
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Form>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <style>
        {`
          @media (max-width: 991px) {
            .account-content {
              padding: 0 20px !important;
              margin-top: 40px !important;
            }
            .points-of-contact-card .ant-card-body,
            .banking-info-card .ant-card-body {
              padding: 12px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Account;
